import React from "react";
import {
  AboutSection,
  CardSection,
  FaqSection,
  GetInvolvedSection,
  HeroSection,
  NewsSection,
  OpportunitySection,
  OurStorySection,
  TeamSection,
} from "../components";

const Home = () => {
  return (
    <>
      {/* Hero section */}
      <HeroSection />

      {/* About us & Story section */}

      <AboutSection />

      {/* Our story section */}

      <OurStorySection />

      {/* Our opportunities section */}

      <OpportunitySection />

      {/* Card Section */}

      <CardSection />

      {/* Our team */}

      <TeamSection />

      {/* News Section */}

      <NewsSection />

      {/* FAQ Section */}

      <FaqSection />
    </>
  );
};

export default Home;
